export enum ReportsPath {
  id = "id",
  email = "email"
}

export interface PathParams {
  [ReportsPath.id]: string;
  [ReportsPath.email]: string;
}
